import { Link, useLocation } from "react-router";
import { isNavActive, type SiteNavItem } from "./site-nav-data";

/** 文字上滚替换：悬停时原文字上移，青色副本从下方补上。副本对读屏隐藏。 */
export function RollText({ text }: { text: string }) {
  return (
    <span className="site-roll">
      <span className="site-roll-track">
        <span>{text}</span>
        <span aria-hidden="true">{text}</span>
      </span>
    </span>
  );
}

/** 岛内导航：当前页面以青色小圆点标记，悬停时文字上滚换成青色。 */
export function SiteHeaderNav({ items }: { items: SiteNavItem[] }) {
  const { pathname } = useLocation();

  return (
    <nav className="site-nav" aria-label="主导航">
      {items.map((item) => (
        <Link key={item.id} to={item.to} aria-current={isNavActive(item, pathname) ? "page" : undefined}>
          <RollText text={item.label} />
        </Link>
      ))}
    </nav>
  );
}
